import { W2Products } from './W2Products'
export default W2Products
